var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"specificationParameter"},[_c('div',{staticClass:"text-title"},[_vm._v("组装规格(单片)")]),_c('assemble-main',{ref:"assembleMain",attrs:{"isEdit":true,"data":_vm.form,"cal":_vm.cal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }